import Header from '../components/Header'
import Footer from '../components/Footer'
import Breadcrumb from "../components/Breadcrumb";
const SchoolInformation = () => {
    return(
        <>
        <Header/>
        <Breadcrumb pageTitle="School Information" mid="About" breadcrumbName="School Information" />
        <div className="container">
            <div className="row">
              
                 <div className='col-md-12'>
                 <h3 class="sub-title">School Information</h3> 
                    <div className='table-responsive'>
                        <table>
                             <tr>
                                <td>Name of the school With Address</td>
                                <td>St. Thomas Sr. Sec. School Civil Line, Mainpuri, Uttar Pradesh - 205001</td>
                             </tr>
                             <tr>
                                <td>E-mail</td>
                                <td><a href="mailto: stthomassrschool@gmail.com">stthomassrschool@gmail.com</a></td>
                             </tr>
                             <tr>
                                <td>Phone Number</td>
                                <td><a href="tel: 7536040116">7536040116</a></td>
                             </tr>
                             <tr>
                                <td>Fax No</td>
                                <td>-</td>
                             </tr>
                             <tr>
                                <td>Year of Establishment of School</td>
                                <td>1976 </td>
                             </tr>
                        </table>
                    </div>
                    
                    <div className='table-responsive'>
                        <table>
                            <thead>
                                <th colSpan="2">hether NOC from state/UT or recommendation of Embassy of India obtained</th>
                            </thead>
                            <tbody>
                             <tr>
                                <td>NOC No.</td>
                                <td>Not Applicable</td>
                             </tr>
                             <tr>
                                <td>NOC issuing date</td>
                                <td>Not Applicable</td>
                             </tr>
                             <tr>
                                <td>Is the schoolb recognized, if yesby which authority Delhi Directorate of Education</td>
                                <td>by which authority Delhi Directorate of Education</td>
                             </tr>
                             <tr>
                                <td>Status of affiliation:</td>
                                <td>Regular</td>
                             </tr>
                             <tr>
                                <td>Affiliation No.</td>
                                <td>2730543 </td>
                             </tr>
                             <tr>
                                <td>Affiliation with the Board since</td>
                                <td>2007 </td>
                             </tr>
                             <tr>
                                <td>Name of Trust/Society/Company</td>
                                <td>St. Thomas Sr. Sec. School </td>
                             </tr>
                             <tr>
                                <td>Period upto which Registration of Trust/Society is valid</td>
                                <td>Permanent </td>
                             </tr>
                             <tr>
                                <td>List of members of School Managing Committee with their Address/tenure and post held</td>
                                <td>ANNEXURE 1 </td>
                             </tr>
                             </tbody>
                        </table>
                    </div> 
                    <div className='table-responsive'>
                        <table>
                        <thead>
                                <th colSpan="2">Name and official address of the Manager/President/Chairman/MANAGER</th>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Name</td>
                                <td>REV. FR. FRANCIS ANTONY</td>
                            </tr>
                            <tr>
                                <td>Address</td>
                                <td>St. Thomas Sr. Sec. School Civil Line, Mainpuri, Uttar Pradesh - 205001</td>
                            </tr>
                            <tr>
                                <td>E-mail</td>
                                <td>stthomassrschool@gmail.com</td>
                            </tr>
                            <tr>
                                <td>Phone number</td>
                                <td><a href="tel:7536040116">7536040116</a></td>
                            </tr>
                            <tr>
                                <td>Fax No</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>Area of school campus</td>
                                <td>4 Acres</td>
                            </tr>
                            <tr>
                                <td>Other facilities</td>
                                <td>-</td>
                            </tr>
                            </tbody>
                        </table>
                    </div> 
                    <div className='table-responsive'>
                        <table>
                        <thead>
                                <th colSpan="2">Name of the Grievance/redressal Officer With E-mail, Ph. No., Fax No.</th>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Name</td>
                                <td>-</td>
                            </tr>
                            <tr>
                                <td>Address</td>
                                <td>Mainpuri</td>
                            </tr>
                            <tr>
                                <td>Email</td>
                                <td><a href="mailto: stthomassrschool@gmail.com">stthomassrschool@gmail.com</a></td>
                            </tr>
                            <tr>
                                <td>Phone</td>
                                <td><a href="mailto: 7536040116">7536040116</a></td>
                            </tr>
                            <tr>
                                <td>Fax No</td>
                                <td>-</td>
                            </tr>
                            <tr>
                                <td>Member of sexual harassment committee </td>
                                <td>-</td>
                            </tr>
                            <tr>
                                <td>Academic session period</td>
                                <td>April to 31 March</td>
                            </tr>
                            <tr>
                                <td>Vacation period</td>
                                <td>Mid May to June end</td>
                            </tr>
                            <tr>
                                <td>Admission period</td>
                                <td>January to June</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                 </div>
            </div>
        </div>
        <p></p>
        <Footer />
        </>
    )
}
export default SchoolInformation